module.exports = __webpack_public_path__ + "img/smoothie.be5030ca.webp";